
import React, { createContext, useContext, useEffect } from 'react';
import CookieConsent from './CookieConsent';
import { useCookieConsent } from '@/hooks/useCookieConsent';

interface GDPRContextType {
  hasAnalyticsConsent: boolean;
}

const GDPRContext = createContext<GDPRContextType>({
  hasAnalyticsConsent: false,
});

export const useGDPR = () => useContext(GDPRContext);

export const GDPRProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { hasConsent, updateAnalyticsConsentMode } = useCookieConsent();
  
  // Apply stored analytics consent on mount.
  useEffect(() => {
    void updateAnalyticsConsentMode();
  }, [updateAnalyticsConsentMode]);
  
  const contextValue: GDPRContextType = {
    hasAnalyticsConsent: hasConsent('analytics'),
  };
  
  return (
    <GDPRContext.Provider value={contextValue}>
      {children}
      <CookieConsent />
    </GDPRContext.Provider>
  );
};

export default GDPRProvider;
